import { Pipe, PipeTransform } from '@angular/core';
export class TdTruncatePipe implements PipeTransform {
/**
 * @param {?} text
 * @param {?} length
 * @return {?}
 */
transform(text: any, length: number): string {
    if (typeof text !== 'string') {
      return '';
    }

    // Truncate
    let /** @type {?} */ truncated: string = text.substr(0, length);

    if (text.length > length) {
      if (truncated.lastIndexOf(' ') > 0) {
        truncated = truncated.trim();
      }

      truncated += '…';
    }

    return truncated;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'truncate',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdTruncatePipe_tsickle_Closure_declarations() {
/** @type {?} */
TdTruncatePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdTruncatePipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
